import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfessionalsRoutes } from './professionals.routing';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProfessionalsComponent } from './pages/professionals.component';
import { ConferencesComponent } from './contents/conferences/conferences.component';
import { HealthComponent } from './contents/health/health.component';

@NgModule({
  imports: [
    CommonModule,
    ProfessionalsRoutes,
    SharedModule
  ],
  declarations: [
    ProfessionalsComponent,
    ConferencesComponent,
    HealthComponent
  ]
})
export class ProfessionalsModule { }
